import { AddAppsUpsell } from "@mirage/growth/onboarding/add-apps-upsell/AddAppsUpsell";
import { ExtensionUpsellBanner } from "@mirage/growth/onboarding/extension-upsell/ExtensionUpsellBanner";
import { useAddAppsUpsellInEmbeddedChat } from "@mirage/mosaics/ComposeAssistant/onboarding/useAddAppsUpsellInEmbeddedChat";
import { useExtensionUpsellInChat } from "@mirage/mosaics/ComposeAssistant/onboarding/useExtensionUpsellInChat";
import { openURL } from "@mirage/service-platform-actions";

import {
  getDeepLinkURL,
  RouteToSlug,
} from "@mirage/shared/fss-bridge/bridgeRouting";

export const EmbeddedUpsells = () => {
  const {
    extensionInfo,
    onDismiss: onDismissExtensionUpsell,
    isLoading,
  } = useExtensionUpsellInChat();

  const { showAddAppsUpsell, onDismiss: onDismissAddAppsUpsell } =
    useAddAppsUpsellInEmbeddedChat();

  const openAddApps = () => {
    onDismissAddAppsUpsell();
    openURL(getDeepLinkURL(RouteToSlug.HOME, { showAddAppsModal: "true" }));
  };

  // Don't render anything until we give extension change to load.
  // This prevents a flash of Add Apps upsell while extension is loading.
  if (isLoading) {
    return null;
  }

  // Extension upsell takes precedence over add apps upsell.
  if (extensionInfo) {
    return (
      <ExtensionUpsellBanner
        extensionInfo={extensionInfo}
        onDismiss={onDismissExtensionUpsell}
        isEmbedded={true}
      />
    );
  }

  if (!showAddAppsUpsell) {
    return null;
  }

  return (
    <AddAppsUpsell
      onDismiss={onDismissAddAppsUpsell}
      onOpenAddApps={openAddApps}
    />
  );
};
